import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';

export default class CustomUrlSerialize implements UrlSerializer {

defaultUrlSerializer = new DefaultUrlSerializer();

    parse(url: string): UrlTree {
        /** 
         You can replace or remove anything from the url as u want
        for ex in this case: 
        /home/hello(world) will become /home/hello%28world%29
        **/

        if(!url) { return this.defaultUrlSerializer.parse(''); }

        url = url.replace(/\(/g, '%28').replace(/\)/g, '%29');

        return this.defaultUrlSerializer.parse(url);
    }

    serialize(tree: UrlTree): string {

        // Decode it back to its original string
        return this.defaultUrlSerializer
            .serialize(tree)
            .replace(/%28/g, '(').replace(/%29/g,')');
    }

}